import React from "react";
import {Button, Segment} from "semantic-ui-react";
import PWAInstallerPrompt from 'react-pwa-installer-prompt';

const Install = () => {
    return (
        <PWAInstallerPrompt
            render={({onClick}) => (
                <Segment
                    attached
                    basic
                    inverted
                >
                    <span style={{paddingRight: 12}}>Recomendamos a instalação para o funcionamento off-line.</span>
                    <Button inverted color={"green"} onClick={onClick}>
                        Instalar
                    </Button>
                </Segment>
            )}
            callback={(data) => console.log(data)}
        />
    );
}

export default Install;